export const TitleText = [
    'Our platform is supported by a highly skilled curation team with a deep-rooted passion for art.',
    'This expertise allows us to create a thoughtfully selected collection of quality artwork and playlists. When you subscribe to our Textura Pro Advanced plan you gain access to personalised playlists, specifically tailored to your industry and requirements.'
]